import React, { useState, useEffect } from "react";
import { MainD, Pill, Ball } from "./MainStyled";

import ballAppearFastSound from "./audio/ballAppearFast.mp3";
import ballSlidingSound from "./audio/ballSliding.mp3";
import ballAppearSlowSound from "./audio/ballAppearSlow.mp3";
// import playSound from "../../../audio/play.mp3";
//
import useSound from "use-sound";
import winSound from "../../../audio/win.mp3";
import tieSound from "../../../audio/tie.mp3";
import lostSound from "../../../audio/lost.mp3";

const colors = [
  "#413f62",
  "#e1be27",
  "#a67ed9",
  "#8cbb67",
  "#fa8046",
  "#828aef",
  "#78bec5",
  "#de4d78",
];

export default function Main({
  betInfo,
  handleIsClickable,
  isFast,
  handleShowText,
  userSettings,
}) {
  const { sound, volume } = userSettings;

  const [ballAppearFastSfx] = useSound(ballAppearFastSound, { volume });
  const [ballSlidingSfx] = useSound(ballSlidingSound, { volume });
  const [ballAppearSlowSfx] = useSound(ballAppearSlowSound, { volume });
  const [winSfx] = useSound(winSound, { volume });
  const [tieSfx] = useSound(tieSound, { volume });
  const [lostSfx] = useSound(lostSound, { volume });

  const [upRow, setupRow] = useState([null, null, null, null, null]);
  const [downRow, setdownRow] = useState([null, null, null, null, null]);

  const [first, setfirst] = useState(true);
  const [fadeOut, setfadeOut] = useState(false);
  const twoToOne = (a, b) => {
    let arr = [null, null, null, null, null];
    return arr.map((x, i) => [a[i], b[i]]);
  };
  const [canScaleUp, setcanScaleUp] = useState(false);
  const [canScaleDown, setcanScaleDown] = useState(false);
  const [lastBetId, setlastBetId] = useState(null);

  useEffect(() => {
    let alreadyShownUp = [];
    let alreadyWinUp = [];

    let alreadyShownDown = [];
    let alreadyWinDown = [];
    if (isFast) {
      if (betInfo.dealer.length === 5 && betInfo.dealer[0] !== "0") {
        if (first) {
          setupRow(twoToOne(betInfo.dealer, betInfo.winPositionsDealer));
          setdownRow(twoToOne(betInfo.player, betInfo.winPositionsPlayer));
          setfirst(false);
          handleShowText(true);
        } else {
          setTimeout(() => {
            handleShowText(true);
            setupRow(twoToOne(betInfo.dealer, betInfo.winPositionsDealer));
            setdownRow(twoToOne(betInfo.player, betInfo.winPositionsPlayer));
            setTimeout(() => {
              if (lastBetId !== betInfo.betid) {
                setlastBetId(betInfo.betid);
                if (sound) ballAppearFastSfx();

                setTimeout(() => {
                  if (sound) ballSlidingSfx();

                  setTimeout(() => {
                    handleIsClickable(true);
                    if (sound) {
                      switch (betInfo.winCoeff) {
                        case 2:
                          if (sound) winSfx();
                          break;
                        case 1.5:
                          if (sound) winSfx();
                          break;
                        case 1:
                          if (sound) tieSfx();
                          break;
                        case 0:
                          if (sound) lostSfx();
                          break;

                        default:
                          break;
                      }
                    }
                  }, 300);
                }, 250);
              }
            }, 50);
          }, 400);
          setTimeout(() => {
            // setcanScale(true);
            // if (betInfo.winCoeff > 1) {
            //   setcanScaleDown(true);
            // } else if (betInfo.winCoeff === 1) {
            //   setcanScaleUp(true);
            //   setcanScaleDown(true);
            // } else {
            //   setcanScaleUp(true);
            // }
            checkForScale(betInfo.winCoeff);
          }, 1167);
        }
      } else if (betInfo.dealer[0] === "0") {
        // For Remove

        if (first) {
          return setfirst(false);
        }

        setfadeOut(true);
        setTimeout(() => {
          setfadeOut(false);
          setcanScaleUp(false);
          setcanScaleDown(false);
          setupRow(twoToOne(betInfo.dealer, betInfo.winPositionsDealer));
          setdownRow(twoToOne(betInfo.player, betInfo.winPositionsPlayer));
          // handleIsClickable(true);
        }, 300);
      }
    } else {
      // slow mode
      if (betInfo.dealer.length === 5 && betInfo.dealer[0] !== "0") {
        if (first) {
          if (lastBetId !== betInfo.betid) {
            setlastBetId(betInfo.betid);

            for (let i = 0; i < 5; i++) {
              setTimeout(() => {
                // if (sound) ballAppearSlowSfx();
                if (alreadyShownUp.includes(betInfo.dealer[i])) {
                  let prevWinnerIndex = alreadyShownUp.indexOf(
                    betInfo.dealer[i]
                  );
                  alreadyShownUp.push(betInfo.dealer[i]);
                  alreadyWinUp[prevWinnerIndex] = "1";
                  alreadyWinUp.push("1");

                  setupRow(twoToOne(alreadyShownUp, alreadyWinUp));
                } else {
                  alreadyShownUp.push(betInfo.dealer[i]);
                  alreadyWinUp.push("0");

                  setupRow(twoToOne(alreadyShownUp, alreadyWinUp));
                }
                if (alreadyShownDown.includes(betInfo.player[i])) {
                  let prevWinnerIndex = alreadyShownDown.indexOf(
                    betInfo.player[i]
                  );
                  alreadyShownDown.push(betInfo.player[i]);
                  alreadyWinDown[prevWinnerIndex] = "1";
                  alreadyWinDown.push("1");

                  setdownRow(twoToOne(alreadyShownDown, alreadyWinDown));
                } else {
                  alreadyShownDown.push(betInfo.player[i]);
                  alreadyWinDown.push("0");

                  setdownRow(twoToOne(alreadyShownDown, alreadyWinDown));
                }
                if (i === 4) {
                  handleShowText(true);

                  setfirst(false);
                  setTimeout(() => {
                    // setcanScale(true);
                    checkForScale(betInfo.winCoeff);

                    handleIsClickable(true);
                  }, 500);
                }
              }, 500 * (i + 1));
            }
          }
        } else {
          if (lastBetId !== betInfo.betid) {
            setlastBetId(betInfo.betid);

            setTimeout(() => {
              for (let i = 0; i < 5; i++) {
                setTimeout(() => {
                  if (sound) ballAppearSlowSfx();
                  if (alreadyShownUp.includes(betInfo.dealer[i])) {
                    setTimeout(() => {
                      if (sound) ballSlidingSfx();
                    }, 350);

                    let prevWinnerIndex = alreadyShownUp.indexOf(
                      betInfo.dealer[i]
                    );
                    alreadyShownUp.push(betInfo.dealer[i]);
                    alreadyWinUp[prevWinnerIndex] = "1";
                    alreadyWinUp.push("1");
                    setupRow(twoToOne(alreadyShownUp, alreadyWinUp));
                  } else {
                    alreadyShownUp.push(betInfo.dealer[i]);
                    alreadyWinUp.push("0");
                    setupRow(twoToOne(alreadyShownUp, alreadyWinUp));
                  }
                  if (i === 4) {
                    handleShowText(true);

                    setTimeout(() => {
                      setTimeout(() => {
                        if (sound) {
                          switch (betInfo.winCoeff) {
                            case 2:
                              if (sound) winSfx();
                              break;
                            case 1.5:
                              if (sound) winSfx();
                              break;
                            case 1:
                              if (sound) tieSfx();
                              break;
                            case 0:
                              if (sound) lostSfx();
                              break;

                            default:
                              break;
                          }
                        }
                      }, 300);

                      handleIsClickable(true);
                      checkForScale(betInfo.winCoeff);
                    }, 500);
                  }
                  if (alreadyShownDown.includes(betInfo.player[i])) {
                    setTimeout(() => {
                      if (sound) ballSlidingSfx();
                    }, 350);
                    let prevWinnerIndex = alreadyShownDown.indexOf(
                      betInfo.player[i]
                    );
                    alreadyShownDown.push(betInfo.player[i]);
                    alreadyWinDown[prevWinnerIndex] = "1";
                    alreadyWinDown.push("1");
                    setdownRow(twoToOne(alreadyShownDown, alreadyWinDown));
                  } else {
                    alreadyShownDown.push(betInfo.player[i]);
                    alreadyWinDown.push("0");
                    setdownRow(twoToOne(alreadyShownDown, alreadyWinDown));
                  }
                }, 500 * (i + 1));
              }
            }, 400);
          }
        }
      } else if (betInfo.dealer[0] === "0") {
        // for remove
        if (first) {
          return setfirst(false);
        }
        setfadeOut(true);

        setTimeout(() => {
          // setcanScale(false);
          setcanScaleUp(false);
          setcanScaleDown(false);
          setfadeOut(false);
          setupRow(twoToOne(betInfo.dealer, betInfo.winPositionsDealer));
          setdownRow(twoToOne(betInfo.player, betInfo.winPositionsPlayer));
          // handleIsClickable(true);
        }, 300);
      }
    }
  }, [
    betInfo,
    first,
    isFast,
    handleIsClickable,
    handleShowText,
    sound,
    ballAppearFastSfx,
    ballSlidingSfx,
    ballAppearSlowSfx,
    betInfo.winAmount,
    lostSfx,
    tieSfx,
    winSfx,
    lastBetId,
  ]);

  const checkForScale = (winCoeff) => {
    if (winCoeff > 1) {
      setcanScaleDown(true);
    } else if (winCoeff === 1) {
      setcanScaleUp(true);
      setcanScaleDown(true);
    } else {
      setcanScaleUp(true);
    }
  };
  return (
    <MainD>
      {upRow.map((b, i) => (
        <Pill key={i}>
          {b && b[0] !== "0" && (
            <Ball
              isDifferent={b[0] === "7"}
              move={b[1] === "1"}
              canScale={canScaleUp}
              color={colors[b[0]]}
              fadeOut={fadeOut}
              delay={!isFast && 500 * i + "ms"}
            />
          )}
        </Pill>
      ))}
      {downRow.map((b, i) => (
        <Pill key={i} downRow>
          {b && b[0] !== "0" && (
            <Ball
              isDifferent={b[0] === "7"}
              move={b[1] === "1"}
              canScale={canScaleDown}
              color={colors[b[0]]}
              fadeOut={fadeOut}
              delay={!isFast && 500 * i + "ms"}
            />
          )}
        </Pill>
      ))}
    </MainD>
  );
}

// isDifferent={b[0] === "7"}
// move={b[1] === "1"}
// color={colors[b[0]]}
